import { Skeleton, Box, Stack } from '@mui/material';

export const BuildingSiteFormSkeleton = () => {
    const fields = Array.from({ length: 4 });

    return (
        <Box sx={{ p: 2, maxWidth: 500, width: '100%', mx: 'auto' }}>
            <Stack spacing={3}>
                <Skeleton variant="text" width={260} height={36} />

                {fields.map((_, i) => (
                    <Box key={i}>
                        <Skeleton variant="text" width={120} height={18} />
                        <Skeleton variant="rectangular" height={36} sx={{ mt: 1 }} />
                    </Box>
                ))}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 1 }} />
                </Box>
            </Stack>
        </Box>
    );
};
